export { default as About } from './About';
export { default as AboutUs } from './AboutUs';
export { default as Careers } from './Careers';
export { default as Contact } from './Contact';
export { default as Help } from './Help';
export { default as Investors } from './Investors';
export { default as Legal } from './Legal';
export { default as Privacy } from './Privacy';
export { default as Support } from './Support';
